import { TFunction } from "i18next";
import * as Yup from "yup";

export const getUserFormSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        surname: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        email: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm"))
            .email(t("common:genericFormErrors.requiredFieldEmailForm")),
        // roles: Yup.array()
        //     .of(Yup.number().required())
        //     .min(1, t("common:form.requiredFieldForm"))
        //     .required(t("common:form.requiredFieldForm"))
    });
